import { AccountNotifications } from './accountModels';
import { Campaign } from './campaignModels';
import { Channel } from './channelModels';
import { CompanyAccount } from './companyModels';
import { CustomerAdvocacyBadgeItemType, CustomerAdvocacyTier } from './customerAdvocacyModels';
import { LoginCustomization, PortalCustomizations, RegisterCustomization, SelectedFormFields } from './customizationModels';
import { AmbassadorError, ServerStatus } from './globalModels';
import { BadgeItemType, LoyaltyTask, LoyaltyTier } from './loyaltyModels';

export type LoginFormType = {
  email: string;
  password: string;
};

export type AuthReducerPropsType = {
  loginStatus?: ServerStatus;
  userStatus?: ServerStatus;
  customizationStatus?: ServerStatus;
  companyStatus?: ServerStatus;
  ambassadorStatus?: ServerStatus;
  notificationsStatus?: ServerStatus;
  changePasswordStatus?: ServerStatus;
  changePasswordMessage?: string;
  changePasswordResponse?: string;
  saveAmbassadorStatus?: ServerStatus;
  saveAmbassadorMessage?: string;
  saveAmbassadorResponse?: SaveAmbassadorResponse;
  saveNotificationsStatus?: ServerStatus;
  unsubscribeStatus?: ServerStatus;
  unsubscribeMessage?: string;
  changeAccountStatus?: ServerStatus;
  user: UserAccount;
  userSSO?: AuthUser;
  companyAccount?: CompanyAccount;
  error?: AmbassadorError;
  ambassadorProfile?: AmbassadorProfile;
  isAccountActive?: boolean;
  loginStatusMessage?: string;
  authStatusMessage?: string;
  accountNotifications?: AccountNotifications;
  activitiesStatus?: ServerStatus;
  activitiesStatusMessage?: string;
  activities?: ActivitiesResponse;
  authValidationResponse?: LoginValidationResponse;
  forgotPasswordStatus?: ServerStatus;
  isEmailSent?: any;
  forgotPasswordStatusMessage?: string;
  registerStatus?: ServerStatus;
  registerStatusMessage?: string;
  registerResponse?: RegisterResponse;
  resetPasswordStatus?: ServerStatus;
  resetPasswordStatusMessage?: string;
  channel: Channel;
};
export type ActivitiesResponse = {
  results?: any; // TODO: MENDOOOOZAAAA, VAIHAVAAAAB!!
};

export type ForgotResponse = {
  email: string;
  detail: string;
  outgoing_email?: string;
};
export type AuthPropTypes = {
  doLogin?: Function;
  getUserData: Function;
  doLogout?: Function;
  doResetLoginStatus: Function;
  handleAccountActivation?: Function;
  getCompanyAccount?: Function;
  setPortalHost?: Function;
  customization?: LoginCustomization;
  doCustomizeLogin?: Function;
  doForgotPassword?: Function;
  doCleanForgotPassword?: Function;
  doResetPassword?: Function;
  portalCustomizations?: PortalCustomizations;
  nonce?: string;
  forgotResponse?: ForgotResponse;
} & AuthReducerPropsType;

export type AccessConsumePropsType = {
  auth: AuthReducerPropsType;
  checkUserRole: Function;
  getProfileData: Function;
  children: JSX.Element;
  roles: Role[];
};

export enum Role {
  admin,
  marketing,
  it,
  accounting,
  internal,
}

export type AuthUser = {
  admin: boolean;
  account: UserAccount;
  // company: Company; -> previous V2 Login
  intercom_hash: string;
  token: string;
  access: number;
};

export type UserAccount = {
  access: number; // 5
  avatar_url: string; //:"https://ambassador-api.s3.amazonaws.com/generic_avatar.png"
  email: string; //: "developerat@getambassador.com"
  first_name: string; // ""
  has_seen: HasSeen; //: {help_dashboard: true, help_commissions: true, help_payouts: true}
  intercom_hash: string; // "ca272068a21a0583119e...8086e3f46b0f904"
  last_name: string; //: ""
  paypal_email: string; //: ""
  registration_date: string; //: "2022-08-31T17:39:23.550170"
  url: string; //: "https://api.getambassador.com/users/132532572/"
  userid: number; // 132532572
  username?: any; //
  version_preferences: { contact_profile: number }; //: { contact_profile: 2 }
  uid: number; // 139659981
  loyalty_access: boolean;
  groups: Group[];
  utm_tracking: boolean;
};

export type CampaignProgram = Campaign & {
  campaign_id: number;
  campaign_name: string;
  campaign_description: string;
  commission_type: string;
  commission_type_text: string;
  commission_amount: number;
  has_access: boolean;
  is_active: boolean;
  program_id?: number;
  program__name?: string;
  recurring_type?: string;
  recurring_type_text?: string;
  recurring_amount?: number;
  is_deleted?: boolean;
  is_hidden_dashboard?: boolean;
  show_share_link_tab?: boolean;
  share_link_tab_text?: string;
  show_share_link_redirect_url?: boolean;
  short_domain?: string;
  allow_custom_links?: boolean;
  allow_multiple_links?: boolean;
  point_name?: string;
  show_earned?: boolean;
  show_awaiting_approval?: boolean;
  show_awaiting_payment?: boolean;
  show_paid_out_so_far?: boolean;
  box_title_1?: string;
  box_title_2?: string;
  box_title_3?: string;
  box_title_4?: string;
  box_image_1?: string;
  show_profile?: boolean;
  show_ads?: boolean;
  show_clicks?: boolean;
  show_revenue?: boolean;
  show_conversions?: boolean;
  show_commissions_graph?: boolean;
  show_logout?: boolean;
  show_stats_tab?: boolean;
  portal_customizations?: any;
  user_message?: string;
  company_message?: string;
  subject?: string;
  refer_a_friend_settings?: any;
};

export type Group = {
  uid: number;
  group_id: number;
  name: string;
  url: string;
};

export type AmbassadorProfile = {
  uid: number; // 139659981
  userid: number; // 115506193
  email: string; // ambassadoracct@getambassador.com
  paypal_email: string;
  dwolla_email: string;
  username: string; // someusername
  first_name: string; // Allan
  last_name: string; // Monterroso
  name: string; //	Allan Monterroso
  current_commission_balance: number; // 0
  current_points_balance: number; // 0
  money_paid: number; // 0
  points_paid: number; // 0
  money_pending: number; // 0
  points_pending: number; //0
  total_money_earned: number; // 0
  total_points_earned: number; // 0
  created_at: string; // 2022-10-24T07:12:02.910537
  updated_at: string; // 2022-10-24T07:12:02.910537
  enrolled_at: string; // 2022-10-24T07:12:02.910537
  memorable_url: string; // https://mbsy.co/BlueSharkEnergyDrink/115506193
  avatar_url: string; // https://ambassador-api.s3.amazonaws.com/generic_avatar.png
  sandbox: boolean; // false
  twitter_username: string; //username
  twitter_url: string; // www.twitter.com/username
  facebook_username: string; //username
  facebook_url: string; // www.facebook.com/username
  linkedin_username: string; // username
  linkedin_url: string; // www.linkedin.com/username
  pinterest_username: string; //username
  pinterest_url: string; // www.linkedin.com/username
  deactivated_by_company: boolean; // false
  deactivated_by_self: boolean; // false
  unsubscribe_from_notifications: boolean; // true
  email_preferences: 'all' | 'none' | 'non-marketing';
  sms_preferences: 'all' | 'none' | 'non-marketing';
  status: string; // enrolled
  remote_customer_id: number; //5488111
  phone: string; //5445888546
  company: string; // somecompany
  street: string; //street name
  city: string; // city name
  state: string; // state
  zip: number; //21102
  country: string; // USA
  payout_preference: number; // 54
  payout_preference_name: string; // Gift Card
  urls: Campaign[];
  campaigns: CampaignProgram[];
  stats: string; // https://api.getambassador.com/ambassadors/139659981/stats/
  shares: string; //	https://api.getambassador.com/ambassadors/139659981/shares/
  commissions: string; // https://api.getambassador.com/ambassadors/139659981/commissions/
  balance: string; // https://api.getambassador.com/ambassadors/139659981/balance/
  vouchers: string; //https://api.getambassador.com/ambassadors/139659981/vouchers/
  access: number; // 5
  sf_contact_id?: string;
  sf_ambassador_id?: string;
  loyalty_points_available: number;
  loyalty_points_earned: number;
  loyalty_points_expired: number;
  loyalty_points_redeemed: number;
  loyalty_points_tier_end: number;
  loyalty_points_tier_start: number;
  loyalty_points_current_tier: CustomerAdvocacyTier | null;
  loyalty_points_next_tier: CustomerAdvocacyTier | null;
  loyalty_cash_available: number;
  loyalty_cash_earned: number;
  loyalty_cash_expired: number;
  loyalty_cash_redeemed: number;
  loyalty_badges: CustomerAdvocacyBadgeItemType[];
  loyalty_tasks: LoyaltyTask[];
  current_tier: LoyaltyTier | null;
  next_tier: LoyaltyTier | null;
  current_tier_progress_value: number;
  badges: BadgeItemType[];
  tiers: LoyaltyTier[];
  rewards_points_earned: number;
  rewards_points_fulfilled: number;
  rewards_points_balance: number;
  rewards_points_redeemed: number;
  rewards_points_expired: number;
  rewards_cash_earned: number;
  rewards_cash_fulfilled: number;
  rewards_cash_balance: number;
  rewards_cash_redeemed: number;
  rewards_cash_expired: number;
  referred_by: AmbassadorProfile;
  date_of_birth: string;
  custom1?: string;
  custom2?: string;
  custom3?: string;
  custom4?: string;
  custom5?: string;
  custom6?: string;
  custom7?: string;
  custom8?: string;
  custom9?: string;
  custom10?: string;
};

export type LocalAuthData = {
  uid: number;
  userId: number;
  companyId: number;
  auth: string;
  host: string;
};

export type ChangePasswordResponse = {
  detail: string;
};

export type SaveAmbassadorResponse = AmbassadorProfile;

export type AccountActivation = {
  deactivated_by_self: boolean;
};

export type AccountActivationResponse = AccountActivation;

export type HasSeen = {
  help_dashboard: boolean;
  help_stats: boolean;
  help_comissions: boolean;
  help_payouts: boolean;
  help_assets: boolean;
  help_sharing: boolean;
  help_profile: boolean;
};

export type LoginValidationResponse = {
  password?: string[];
  email?: string[];
  non_field_errors?: string[];
  detail?: string;
};

export type ForgotPasswordValidationResponse = {
  email: string[];
  non_field_errors: string[];
};

export type RegisterPropsType = {
  customization: RegisterCustomization;
  ambassadorStatus?: ServerStatus;
  userStatus?: ServerStatus;
  customizationStatus?: ServerStatus;
  registerStatusMessage?: string;
  registerStatus?: ServerStatus;
  formFields: SelectedFormFields;
  companyId: number;
  companyName: string;
  registerResponse?: RegisterResponse;
  nonce?: string;
};

export type RegisterFormData = {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  paypal_email?: string;
  company_name?: string;
  street?: string;
  city?: string;
  state?: string;
  country?: string;
  zip?: string;
  custom1?: string;
  custom2?: string;
  custom3?: string;
  custom4?: string;
  custom5?: string;
  custom6?: string;
  custom7?: string;
  custom8?: string;
  custom9?: string;
  custom10?: string;
  groups?: number;
  job_title?: string;
  terms?: boolean;
  recaptcha?: string;
  is_loyalty?: boolean;
  short_code?: string;
};

export type ForgotPasswordFormType = {
  email: string;
};

export type RegisterResponse = {
  account?: UserAccount;
  account_initializing?: boolean;
  token?: string;
  detail?: string;
  [field: string]: any; // used to track multiple field validation responses
};

export enum ReCaptchaAction {
  REGISTER = 'REGISTER',
  LOGIN = 'LOGIN',
  REDEEM = 'REDEEM',
}

export type ReCaptchaResponse = {
  isValid?: boolean;
  score: number;
  token: string;
  reason: [];
  status: string;
};

export type ResetPasswordFormData = {
  email?: string;
  password?: string;
  repeat_password?: string;
  code?: string;
};

export type ResetPasswordValidationResponse = {
  email: string[];
  non_field_errors: string[];
};

export type ResetPasswordResponse = {
  token: string;
  account: UserAccount;
  detail: string;
};

export type StoreFrontValidationResponse = {
  valid: boolean;
  two_factor_enabled?: boolean;
  fields?: string[];
  company_id?: number;
};
